/**
 * confirmDialog — confirmación imperativa con estilo de marca.
 *
 * Reemplaza al `window.confirm()` nativo (que rompe la estética dark de ONOR y
 * es inconsistente entre navegadores) por un diálogo temado. Se usa igual de
 * simple que el nativo, pero devuelve una Promesa:
 *
 *   if (!(await confirmDialog({ message: '¿Eliminar?', danger: true }))) return;
 *
 * El host (<ConfirmHost/>, montado una vez en App) registra el manejador. Si
 * por alguna razón el host no está montado, cae de forma segura al confirm
 * nativo para no bloquear una acción destructiva.
 *
 * Opciones: { title, message, confirmLabel, cancelLabel, danger }
 */
let handler = null;

export function registerConfirm(fn) {
  handler = fn;
}

export function confirmDialog(opts = {}) {
  const options = typeof opts === 'string' ? { message: opts } : opts;
  if (!handler) {
    // Fallback seguro: nunca dejar una acción sin poder confirmarse.
    return Promise.resolve(
      window.confirm(options.message || options.title || '¿Confirmar esta acción?'),
    );
  }
  return new Promise((resolve) => handler(options, resolve));
}
